"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};

var __await = this && this.__await || function (v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
};

var __asyncDelegator = this && this.__asyncDelegator || function (o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) {
    throw e;
  }), verb("return"), i[Symbol.iterator] = function () {
    return this;
  }, i;

  function verb(n, f) {
    i[n] = o[n] ? function (v) {
      return (p = !p) ? {
        value: __await(o[n](v)),
        done: n === "return"
      } : f ? f(v) : v;
    } : f;
  }
};

var __asyncGenerator = this && this.__asyncGenerator || function (thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeploymentFields = exports.ContentClient = void 0;

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var async_iterator_to_array_1 = __importDefault(require("async-iterator-to-array"));

var stream_1 = require("stream");

var Helper_1 = require("./utils/Helper");

var form_data_1 = __importDefault(require("form-data"));

var ContentClient = /*#__PURE__*/function () {
  function ContentClient(contentUrl, origin, // The name or a description of the app that is using the client
  fetcher) {
    _classCallCheck(this, ContentClient);

    this.origin = origin;
    this.KNOWN_HEADERS = ['Content-Type', 'Access-Control-Allow-Origin', 'Access-Control-Expose-Headers', 'ETag', 'Date', 'Content-Length', 'Cache-Control'];
    this.contentUrl = Helper_1.sanitizeUrl(contentUrl);
    this.fetcher = fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher({
      headers: Helper_1.getHeadersWithUserAgent('content-client')
    });
  }

  _createClass(ContentClient, [{
    key: "deployEntity",
    value: function () {
      var _deployEntity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(deployData) {
        var fix,
            options,
            areWeRunningInNode,
            form,
            alreadyUploadedHashes,
            _iterator,
            _step,
            _step$value,
            fileHash,
            file,
            requestOptions,
            _yield$this$fetcher$p,
            creationTimestamp,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fix = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                options = _args.length > 2 ? _args[2] : undefined;
                // Check if we are running in node or browser
                areWeRunningInNode = Helper_1.isNode(); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore

                form = areWeRunningInNode ? new form_data_1.default() : new FormData();
                form.append('entityId', deployData.entityId);
                Helper_1.addModelToFormData(deployData.authChain, form, 'authChain');
                _context.next = 8;
                return this.hashesAlreadyOnServer(Array.from(deployData.files.keys()), options);

              case 8:
                alreadyUploadedHashes = _context.sent;
                _iterator = _createForOfIteratorHelper(deployData.files);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    _step$value = _slicedToArray(_step.value, 2), fileHash = _step$value[0], file = _step$value[1];

                    if (!alreadyUploadedHashes.has(fileHash) || fileHash === deployData.entityId) {
                      if (areWeRunningInNode) {
                        // Node
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        form.append(file.name, file.content, file.name);
                      } else {
                        // Browser
                        form.append(file.name, new Blob([file.content.buffer]), file.name);
                      }
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                requestOptions = dcl_catalyst_commons_1.mergeRequestOptions(options !== null && options !== void 0 ? options : {}, {
                  body: form,
                  headers: {
                    'x-upload-origin': this.origin
                  }
                });
                _context.next = 14;
                return this.fetcher.postForm("".concat(this.contentUrl, "/entities").concat(fix ? '?fix=true' : ''), requestOptions);

              case 14:
                _yield$this$fetcher$p = _context.sent;
                creationTimestamp = _yield$this$fetcher$p.creationTimestamp;
                return _context.abrupt("return", creationTimestamp);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function deployEntity(_x) {
        return _deployEntity.apply(this, arguments);
      }

      return deployEntity;
    }()
  }, {
    key: "fetchEntitiesByPointers",
    value: function fetchEntitiesByPointers(type, pointers, options) {
      if (pointers.length === 0) {
        return Promise.reject("You must set at least one pointer.");
      }

      return Helper_1.splitAndFetch({
        fetcher: this.fetcher,
        baseUrl: this.contentUrl,
        path: "/entities/".concat(type),
        queryParams: {
          name: 'pointer',
          values: pointers
        },
        uniqueBy: 'id',
        options: options
      });
    }
  }, {
    key: "fetchEntitiesByIds",
    value: function fetchEntitiesByIds(type, ids, options) {
      if (ids.length === 0) {
        return Promise.reject("You must set at least one id.");
      }

      return Helper_1.splitAndFetch({
        fetcher: this.fetcher,
        baseUrl: this.contentUrl,
        path: "/entities/".concat(type),
        queryParams: {
          name: 'id',
          values: ids
        },
        uniqueBy: 'id',
        options: options
      });
    }
  }, {
    key: "fetchEntityById",
    value: function () {
      var _fetchEntityById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(type, id, options) {
        var entities;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchEntitiesByIds(type, [id], options);

              case 2:
                entities = _context2.sent;

                if (!(entities.length === 0)) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", Promise.reject("Failed to find an entity with type '".concat(type, "' and id '").concat(id, "'.")));

              case 5:
                return _context2.abrupt("return", entities[0]);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchEntityById(_x2, _x3, _x4) {
        return _fetchEntityById.apply(this, arguments);
      }

      return fetchEntityById;
    }()
  }, {
    key: "fetchAuditInfo",
    value: function fetchAuditInfo(type, id, options) {
      return this.fetchJson("/audit/".concat(type, "/").concat(id), options);
    }
  }, {
    key: "fetchContentStatus",
    value: function fetchContentStatus(options) {
      return this.fetchJson('/status', options);
    }
  }, {
    key: "downloadContent",
    value: function () {
      var _downloadContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(contentHash, options) {
        var _this = this;

        var _ref, _ref$attempts, attempts, _ref$waitTime, waitTime, timeout;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _ref = options !== null && options !== void 0 ? options : {}, _ref$attempts = _ref.attempts, attempts = _ref$attempts === void 0 ? 3 : _ref$attempts, _ref$waitTime = _ref.waitTime, waitTime = _ref$waitTime === void 0 ? '0.5s' : _ref$waitTime;
                timeout = (options === null || options === void 0 ? void 0 : options.timeout) ? {
                  timeout: options.timeout
                } : {};
                return _context4.abrupt("return", dcl_catalyst_commons_1.retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                  var content, downloadedHash;
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return _this.fetcher.fetchBuffer("".concat(_this.contentUrl, "/contents/").concat(contentHash), timeout);

                        case 2:
                          content = _context3.sent;
                          _context3.next = 5;
                          return dcl_catalyst_commons_1.Hashing.calculateBufferHash(content);

                        case 5:
                          downloadedHash = _context3.sent;

                          if (!(downloadedHash === contentHash)) {
                            _context3.next = 8;
                            break;
                          }

                          return _context3.abrupt("return", content);

                        case 8:
                          throw new Error("Failed to fetch file with hash ".concat(contentHash, " from ").concat(_this.contentUrl));

                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                })), attempts, waitTime));

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function downloadContent(_x5, _x6) {
        return _downloadContent.apply(this, arguments);
      }

      return downloadContent;
    }()
  }, {
    key: "pipeContent",
    value: function () {
      var _pipeContent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(contentHash, writeTo, options) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.t0 = this;
                _context5.next = 3;
                return this.fetcher.fetchPipe("".concat(this.contentUrl, "/contents/").concat(contentHash), writeTo, options);

              case 3:
                _context5.t1 = _context5.sent;
                return _context5.abrupt("return", _context5.t0.onlyKnownHeaders.call(_context5.t0, _context5.t1));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function pipeContent(_x7, _x8, _x9) {
        return _pipeContent.apply(this, arguments);
      }

      return pipeContent;
    }()
  }, {
    key: "fixHeaderNameCase",
    value: function fixHeaderNameCase(headerName) {
      return this.KNOWN_HEADERS.find(function (item) {
        return item.toLowerCase() === headerName.toLowerCase();
      });
    }
  }, {
    key: "onlyKnownHeaders",
    value: function onlyKnownHeaders(headersFromResponse) {
      var _this2 = this;

      var headers = new Map();
      headersFromResponse === null || headersFromResponse === void 0 ? void 0 : headersFromResponse.forEach(function (headerValue, headerName) {
        var fixedHeader = _this2.fixHeaderNameCase(headerName);

        if (fixedHeader) {
          headers.set(fixedHeader, headerValue);
        }
      });
      return headers;
    }
    /**
     * This method fetches all deployments that match the given filters.
     *  It is important to mention, that if there are too many filters, then the URL might get too long.
     *  In that case, we will internally make the necessary requests,
     *  but then the order of the deployments is not guaranteed.
     */

  }, {
    key: "fetchAllDeployments",
    value: function fetchAllDeployments(deploymentOptions, options) {
      return async_iterator_to_array_1.default(this.iterateThroughDeployments(deploymentOptions, options));
    }
  }, {
    key: "streamAllDeployments",
    value: function streamAllDeployments(deploymentOptions, options) {
      return stream_1.Readable.from(this.iterateThroughDeployments(deploymentOptions, options));
    }
  }, {
    key: "iterateThroughDeployments",
    value: function iterateThroughDeployments(deploymentOptions, options) {
      var _a;

      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function iterateThroughDeployments_1() {
        var _this3 = this;

        var withSomeDefaults, filterQueryParams, sortingQueryParams, queryParams, fieldsValue, reservedParams, modifyQueryBasedOnResult, canWeUseLocalTimestampInsteadOfOffset;
        return _regeneratorRuntime.wrap(function iterateThroughDeployments_1$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // We are setting different defaults in this case, because if one of the request fails, then all fail
                withSomeDefaults = dcl_catalyst_commons_1.applySomeDefaults({
                  attempts: 3,
                  waitTime: '1s'
                }, options); // Validate that some params were used, so that not everything is fetched

                this.assertFiltersAreSet(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.filters); // Transform filters object into query params map

                filterQueryParams = Helper_1.convertFiltersToQueryParams(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.filters); // Transform sorting object into query params map

                sortingQueryParams = this.sortingToQueryParams(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.sortBy); // Initialize query params with filters and sorting

                queryParams = new Map([].concat(_toConsumableArray(filterQueryParams), _toConsumableArray(sortingQueryParams)));

                if (deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.fields) {
                  fieldsValue = deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.fields.getFields();
                  queryParams.set('fields', [fieldsValue]);
                }

                canWeUseLocalTimestampInsteadOfOffset = (deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.fields) && deploymentOptions.fields.isFieldIncluded('auditInfo') && (!(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.sortBy) || deploymentOptions.sortBy.field === dcl_catalyst_commons_1.SortingField.LOCAL_TIMESTAMP);

                if (canWeUseLocalTimestampInsteadOfOffset) {
                  // Note: the approach used below will get stuck if all 500 deployments on the same page have the same localTimestamp, but that is extremely unlikely
                  reservedParams = new Map([['fromLocalTimestamp', 13], ['toLocalTimestamp', 13]]);

                  if (((_a = deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.sortBy) === null || _a === void 0 ? void 0 : _a.order) === dcl_catalyst_commons_1.SortingOrder.ASCENDING) {
                    // Ascending
                    modifyQueryBasedOnResult = function modifyQueryBasedOnResult(result, builder) {
                      return _this3.setParamBasedOnResult('fromLocalTimestamp', result, builder);
                    };
                  } else {
                    // Descending
                    modifyQueryBasedOnResult = function modifyQueryBasedOnResult(result, builder) {
                      return _this3.setParamBasedOnResult('toLocalTimestamp', result, builder);
                    };
                  }
                } else {
                  // We will use offset then
                  reservedParams = new Map([['offset', ContentClient.CHARS_LEFT_FOR_OFFSET]]);

                  modifyQueryBasedOnResult = function modifyQueryBasedOnResult(result, queryBuilder) {
                    return queryBuilder.setParam('offset', result.pagination.limit + result.pagination.offset);
                  };
                }

                _context6.t0 = __await;
                return _context6.delegateYield(__asyncDelegator(__asyncValues(this.iterateThroughDeploymentsBasedOnResult(queryParams, reservedParams, modifyQueryBasedOnResult, deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.errorListener, withSomeDefaults))), "t1", 10);

              case 10:
                _context6.t2 = _context6.t1;
                _context6.next = 13;
                return (0, _context6.t0)(_context6.t2);

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, iterateThroughDeployments_1, this);
      }));
    }
  }, {
    key: "iterateThroughDeploymentsBasedOnResult",
    value: function iterateThroughDeploymentsBasedOnResult(queryParams, reservedParams, modifyQueryBasedOnResult, errorListener, options) {
      return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function iterateThroughDeploymentsBasedOnResult_1() {
        var builders, foundIds, exit, i, queryBuilder, keepRetrievingHistory, url, partialHistory, _iterator2, _step2, deployment;

        return _regeneratorRuntime.wrap(function iterateThroughDeploymentsBasedOnResult_1$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // Split values into different queries
                builders = Helper_1.splitValuesIntoManyQueryBuilders({
                  baseUrl: this.contentUrl,
                  path: '/deployments',
                  queryParams: queryParams,
                  reservedParams: reservedParams
                }); // Perform the different queries

                foundIds = new Set();
                exit = false;
                i = 0;

              case 4:
                if (!(i < builders.length && !exit)) {
                  _context7.next = 47;
                  break;
                }

                queryBuilder = builders[i];
                keepRetrievingHistory = true;

              case 7:
                if (!(keepRetrievingHistory && !exit)) {
                  _context7.next = 44;
                  break;
                }

                url = queryBuilder.toString();
                _context7.prev = 9;
                _context7.next = 12;
                return __await(this.fetcher.fetchJson(url, options));

              case 12:
                partialHistory = _context7.sent;
                _iterator2 = _createForOfIteratorHelper(partialHistory.deployments);
                _context7.prev = 14;

                _iterator2.s();

              case 16:
                if ((_step2 = _iterator2.n()).done) {
                  _context7.next = 26;
                  break;
                }

                deployment = _step2.value;

                if (foundIds.has(deployment.entityId)) {
                  _context7.next = 24;
                  break;
                }

                foundIds.add(deployment.entityId);
                _context7.next = 22;
                return __await(deployment);

              case 22:
                _context7.next = 24;
                return _context7.sent;

              case 24:
                _context7.next = 16;
                break;

              case 26:
                _context7.next = 31;
                break;

              case 28:
                _context7.prev = 28;
                _context7.t0 = _context7["catch"](14);

                _iterator2.e(_context7.t0);

              case 31:
                _context7.prev = 31;

                _iterator2.f();

                return _context7.finish(31);

              case 34:
                modifyQueryBasedOnResult(partialHistory, queryBuilder);
                keepRetrievingHistory = partialHistory.pagination.moreData;
                _context7.next = 42;
                break;

              case 38:
                _context7.prev = 38;
                _context7.t1 = _context7["catch"](9);

                if (errorListener) {
                  errorListener("".concat(_context7.t1));
                }

                exit = true;

              case 42:
                _context7.next = 7;
                break;

              case 44:
                i++;
                _context7.next = 4;
                break;

              case 47:
              case "end":
                return _context7.stop();
            }
          }
        }, iterateThroughDeploymentsBasedOnResult_1, this, [[9, 38], [14, 28, 31, 34]]);
      }));
    }
  }, {
    key: "setParamBasedOnResult",
    value: function setParamBasedOnResult(paramName, result, builder) {
      var lastDeployment = result.deployments[result.deployments.length - 1];

      if (lastDeployment) {
        // @ts-ignore
        builder.setParam(paramName, lastDeployment.auditInfo.localTimestamp);
      }
    }
  }, {
    key: "assertFiltersAreSet",
    value: function assertFiltersAreSet(filters) {
      var filtersAreSet = (filters === null || filters === void 0 ? void 0 : filters.fromLocalTimestamp) || (filters === null || filters === void 0 ? void 0 : filters.toLocalTimestamp) || (filters === null || filters === void 0 ? void 0 : filters.deployedBy) && (filters === null || filters === void 0 ? void 0 : filters.deployedBy.length) > 0 || (filters === null || filters === void 0 ? void 0 : filters.entityTypes) && (filters === null || filters === void 0 ? void 0 : filters.entityTypes.length) > 0 || (filters === null || filters === void 0 ? void 0 : filters.entityIds) && (filters === null || filters === void 0 ? void 0 : filters.entityIds.length) > 0 || (filters === null || filters === void 0 ? void 0 : filters.pointers) && (filters === null || filters === void 0 ? void 0 : filters.pointers.length) > 0;

      if (!filtersAreSet) {
        throw new Error("When fetching deployments, you must set at least one filter that isn't 'onlyCurrentlyPointed'");
      }
    }
  }, {
    key: "sortingToQueryParams",
    value: function sortingToQueryParams(sort) {
      var sortQueryParams = new Map();

      if (sort === null || sort === void 0 ? void 0 : sort.field) {
        sortQueryParams.set('sortingField', [sort.field]);
      }

      if (sort === null || sort === void 0 ? void 0 : sort.order) {
        sortQueryParams.set('sortingOrder', [sort.order]);
      }

      return sortQueryParams;
    }
  }, {
    key: "isContentAvailable",
    value: function isContentAvailable(cids, options) {
      if (cids.length === 0) {
        return Promise.reject("You must set at least one cid.");
      }

      return Helper_1.splitAndFetch({
        fetcher: this.fetcher,
        baseUrl: this.contentUrl,
        path: "/available-content",
        queryParams: {
          name: 'cid',
          values: cids
        },
        uniqueBy: 'cid',
        options: options
      });
    }
  }, {
    key: "getContentUrl",
    value: function getContentUrl() {
      return this.contentUrl;
    }
    /** Given an array of file hashes, return a set with those already uploaded on the server */

  }, {
    key: "hashesAlreadyOnServer",
    value: function () {
      var _hashesAlreadyOnServer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(hashes, options) {
        var result, alreadyUploaded;
        return _regeneratorRuntime.wrap(function _callee6$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.isContentAvailable(hashes, options);

              case 2:
                result = _context8.sent;
                alreadyUploaded = result.filter(function (_ref3) {
                  var available = _ref3.available;
                  return available;
                }).map(function (_ref4) {
                  var cid = _ref4.cid;
                  return cid;
                });
                return _context8.abrupt("return", new Set(alreadyUploaded));

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee6, this);
      }));

      function hashesAlreadyOnServer(_x10, _x11) {
        return _hashesAlreadyOnServer.apply(this, arguments);
      }

      return hashesAlreadyOnServer;
    }()
  }, {
    key: "fetchJson",
    value: function fetchJson(path, options) {
      return this.fetcher.fetchJson("".concat(this.contentUrl).concat(path), options);
    }
  }]);

  return ContentClient;
}();

exports.ContentClient = ContentClient;
ContentClient.CHARS_LEFT_FOR_OFFSET = 7; // eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore

var DeploymentFields = /*#__PURE__*/function () {
  function DeploymentFields(fields) {
    _classCallCheck(this, DeploymentFields);

    this.fields = fields;
  }

  _createClass(DeploymentFields, [{
    key: "getFields",
    value: function getFields() {
      return this.fields.join(',');
    }
  }, {
    key: "isFieldIncluded",
    value: function isFieldIncluded(name) {
      return this.fields.includes(name);
    }
  }]);

  return DeploymentFields;
}();

exports.DeploymentFields = DeploymentFields;
DeploymentFields.AUDIT_INFO = new DeploymentFields(['auditInfo']);
DeploymentFields.POINTERS_CONTENT_METADATA_AND_AUDIT_INFO = new DeploymentFields(['pointers', 'content', 'metadata', 'auditInfo']);
DeploymentFields.POINTERS_CONTENT_AND_METADATA = new DeploymentFields(['pointers', 'content', 'metadata']);